export type TMainFrameState = {
    showUI: boolean;
    showPreloader: boolean;
};

export const RC_MAIN_FRAME_DEFAULTS = {
    showUI: false,
    showPreloader: false
};
